import React from 'react';

function Home() {
    return (
        <h1>{/*this is the homepage*/}</h1>
    );
}

export default Home;